import Loader from "../../components/common/Loader";
import RulesList from "./components/rulesList";
import { useRules } from "./hooks/useRules";
import "./styles/Rules.css";
import { useMemo } from "react";
import { useLocation } from "react-router";
import type {
	DispatchRule,
	DispatchRuleParams,
	NotificationMethod,
} from "./types/rules.types";

function useQueryParams() {
	const { search } = useLocation();

	return useMemo(() => {
		const params = new URLSearchParams(search);

		return {
			showInactive: params.get("showInactive"),
		};
	}, [search]);
}

export default function Rules() {
	const query: DispatchRuleParams = useQueryParams();

	const {
		loading,
		rulesData,
		getRulesData,
		showInactiveRules,
		updateShowInactiveRules,
		showCreateRuleModal,
		updateShowCreateRuleModal,
		profitCenters,
		selectedProfitCenterId,
		updateSelectedProfitCenterId,
		clearSelectedProfitCenterId,
		checkedDefaultNotificationType,
		updateCheckedDefaultNotificationType,
		clearCheckedDefaultNotificationType,
		checkedUpdateNotificationType,
		updateCheckedUpdateNotificationType,
		clearCheckedUpdateNotificationType,
		checkedCancelNotificationType,
		updateCheckedCancelNotificationType,
		clearCheckedCancelNotificationType,
		checkedRecallNotificationType,
		updateCheckedRecallNotificationType,
		clearCheckedRecallNotificationType,
		TicketNotificationConfigs,
		ruleTypes,
		selectedRuleTypeId,
		updateSelectedRuleTypeId,
		createRule,
		selectedStartTime,
		selectedEndTime,
		updateSelectedStartTime,
		updateSelectedEndTime,
		clearselectedRuleTypeId,
		clearSelectedStartTime,
		clearSelectedEndTime,
		canCreateRule,
		handleRuleRowClick,
		showEditRuleModal,
		updateShowEditRuleModal,
		EditTicketNotificationConfigs,
		editRuleTypeId,
		updateEditRuleTypeId,
		editProfitCenterId,
		updateEditProfitCenterId,
		editStartTime,
		updateEditStartTime,
		editEndTime,
		updateEditEndTime,
		canEditRule,
		editRule,
		canDeleteRule,
		deleteRule,
	} = useRules(query);

	return (
		<div className="dispatchRulesContainer">
			<div>
				<h2>Automation Rules</h2>
			</div>
			{loading && (
				<div>
					<Loader title="Loading Dispatch Rules" />
				</div>
			)}
			{!loading && (
				<RulesList
					rulesData={rulesData}
					getRulesData={getRulesData}
					showInactiveRules={showInactiveRules}
					updateShowInactiveRules={(show: boolean) =>
						updateShowInactiveRules(show)
					}
					showCreateRuleModal={showCreateRuleModal}
					updateShowCreateRuleModal={(show: boolean) =>
						updateShowCreateRuleModal(show)
					}
					profitCenters={profitCenters}
					selectedProfitCenterId={selectedProfitCenterId}
					updateSelectedProfitCenterId={(id: string) =>
						updateSelectedProfitCenterId(id)
					}
					clearSelectedProfitCenterId={clearSelectedProfitCenterId}
					checkedDefaultNotificationType={checkedDefaultNotificationType}
					updateCheckedDefaultNotificationType={(method: NotificationMethod) =>
						updateCheckedDefaultNotificationType(method)
					}
					clearCheckedDefaultNotificationType={
						clearCheckedDefaultNotificationType
					}
					checkedUpdateNotificationType={checkedUpdateNotificationType}
					updateCheckedUpdateNotificationType={(method: NotificationMethod) =>
						updateCheckedUpdateNotificationType(method)
					}
					clearCheckedCancelNotificationType={
						clearCheckedCancelNotificationType
					}
					checkedCancelNotificationType={checkedCancelNotificationType}
					updateCheckedCancelNotificationType={(method: NotificationMethod) =>
						updateCheckedCancelNotificationType(method)
					}
					clearCheckedUpdateNotificationType={
						clearCheckedUpdateNotificationType
					}
					checkedRecallNotificationType={checkedRecallNotificationType}
					updateCheckedRecallNotificationType={(method: NotificationMethod) =>
						updateCheckedRecallNotificationType(method)
					}
					clearCheckedRecallNotificationType={
						clearCheckedRecallNotificationType
					}
					TicketNotificationConfigs={TicketNotificationConfigs}
					ruleTypes={ruleTypes}
					selectedRuleTypeId={selectedRuleTypeId}
					updateSelectedRuleTypeId={(id: string) =>
						updateSelectedRuleTypeId(id)
					}
					createRule={() => createRule()}
					selectedStartTime={selectedStartTime}
					selectedEndTime={selectedEndTime}
					updateSelectedStartTime={(time: string) =>
						updateSelectedStartTime(time)
					}
					updateSelectedEndTime={(time: string) => updateSelectedEndTime(time)}
					clearSelectedRuleTypeId={clearselectedRuleTypeId}
					clearSelectedStartTime={clearSelectedStartTime}
					clearSelectedEndTime={clearSelectedEndTime}
					canCreateRule={canCreateRule}
					handleRuleRowClick={(rule: DispatchRule) => handleRuleRowClick(rule)}
					showEditRuleModal={showEditRuleModal}
					updateShowEditRuleModal={(show: boolean) =>
						updateShowEditRuleModal(show)
					}
					EditTicketNotificationConfigs={EditTicketNotificationConfigs}
					editRuleTypeId={editRuleTypeId}
					updateEditRuleTypeId={(id: string) => updateEditRuleTypeId(id)}
					editProfitCenterId={editProfitCenterId}
					updateEditProfitCenterId={(id: string) =>
						updateEditProfitCenterId(id)
					}
					editStartTime={editStartTime}
					updateEditStartTime={(time: string) => updateEditStartTime(time)}
					editEndTime={editEndTime}
					updateEditEndTime={(time: string) => updateEditEndTime(time)}
					canEditRule={canEditRule}
					editRule={() => editRule()}
					canDeleteRule={canDeleteRule}
					deleteRule={() => deleteRule()}
				/>
			)}
		</div>
	);
}
